//console.log("Initialize App");
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import router from './router';
import App from './components/App.vue';
import Cookies from 'js-cookie';

import util from './plugins/util';
import db_plugin from './plugins/db';
import download_plugin from './plugins/download';
import filters from './plugins/filters';
import dialog from './plugins/dialog';

import store from './store'

require('./bootstrap');
window.Cookies = Cookies;

Vue.use(util.ELearningPlugin);
Vue.use(db_plugin);
Vue.use(download_plugin)
Vue.use(filters);
Vue.use(dialog);

/**
 * ドキュメントルートの設定
 * @type {string}
 */
var docRoot = process.env.MIX_VUEROOTER_BASE;

axios.defaults.baseURL = docRoot + '/apis/';
axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-with': 'XMLHttpRequest',
};
axios.defaults.withCredentials = true;

// 2019-10-05 ando : サーバー上でログインしているかどうかで API を使えるかどうかを判断できるはずだが、
// 元の実装が、それとは別にトークン el-auth-token を使用していたので、そのまま生かす。が、サーバー上でちゃんとトークンをチェックしているか、確認が必要
// 2019-10-28 kato PWA作業スケジュール No.37 にて ↑
// 見当たらず、@package App\Http\Middleware class AddMetadata でチェック実装。
axios.interceptors.request.use(function(config) {
    var authToken = Cookies.get('el-auth-token');
    if (authToken) {
        config.headers['el-auth-token'] = authToken;
    } else {
        config.headers['el-auth-token'] = 'unauthorized';
    }

    return config;
});
Vue.prototype.$http = axios;

/**
 * インターセプター(認証管理および画面タイトル変更)
 * 
 * @todo router.afterEach に移すべき処理は移す
 */
router.beforeEach((to, from, next) => {

    // ando
    console.log("router.beforeEach :", to, from, next);

    // ログインが必要かどうか？
    const requires_auth = to.matched.some(r => r.meta.requiresAuth);

    console.log("requiresAuth : ", requires_auth);

    var authToken = Cookies.get('el-auth-token');

    // ページ遷移制御
    if (requires_auth && !authToken && Vue.Download.isOnline()) {
        console.warn('ログインしてください');
        next({ path: '/login' });

    } else {
        // アプリ設定・情報取得（ユーザー数/管理者ユーザー/ディスク容量/ユーザー上限数/使用ディスクサイズ）
        var handler = Vue.ELearning.appInfo.get();
        handler.then(res => {
            if (res.data.status_number == 200) {

                var appInfo = res.data.content;

                // ユーザー情報
                store.commit('appInfo', appInfo);

                // 使用ファイルサイズ
                var file_size_num_gb = Math.round(appInfo.fileSizeSum / (1024 * 1024 * 1024) * 100) / 100;
                store.commit('fileSizeSum', file_size_num_gb);

            } else {
                // status 200 以外が返って来たらログイン画面に遷移する。
                if (Vue.Download.isOnline()) {
                    emTransit.apply(this, [to, from, next, store, 'アプリ情報取得']);
                }
            }
        });

        /* 2020/03/13 廃止 AppInfoと統合移植
        // 使用ファイルサイズ取得
        var handler = Vue.ELearning.Checklist.getFileSizeSum();
        handler.then(res => {
            if (res.data.status_number == 200) {
                var file_size_num = res.data.content.payload;
                if (file_size_num === undefined) {
                    file_size_num = 0;
                }
                var file_size_num_gb = Math.round(file_size_num / (1024 * 1024 * 1024) * 100) / 100;

                store.commit('fileSizeSum', file_size_num_gb);
            } else {
                // 2019-10-28 kato PWA作業スケジュール No.37
                // status 200 以外が返って来たらログイン画面に遷移する。
                // 使用ファイルサイズ取得に抱き合わせる
                if (Vue.Download.isOnline()) {
                    emTransit.apply(this, [to, from, next, store, '使用ファイルサイズ取得']);
                }
            }
        });
        */

        // 2019-10-05 ando : 怪しいので調べる
        // ログイン済かつユーザ情報が存在しない場合は
        // ユーザ情報取得APIにてユーザ情報を取得した後に遷移する
        if (!store) {
            // 2019-10-28 kato PWA作業スケジュール No.37
            // セッション消失により storeの定義が遅れる？ない？ことがある
            if (Vue.Download.isOnline()) {
                emTransit.apply(this, [to, from, next, null, 'storeなし']);
            }

        } else if (store.userInfo && store.userInfo.grant == undefined) {
            // 権限情報未設定の場合は
            // サーバに権限を問い合わせる

            var handler = Vue.ELearning.UserInfo.current();
            handler
                .then(res => {
                    if (res.data.status_number == 200) {
                        var userInfo = res.data.content;
                        if (res.data.content.payload == null && userInfo.user_id !== 'undefined' && userInfo.user_id != '') {
                            store.commit('login', {
                                userId: userInfo.user_id,
                                userName: userInfo.user_name,
                                grant: userInfo.grant_id,
                            });
                        }

                        // 画面タイトルを変更する
                        const title = to.meta.title;

                        store.commit('updateTitle', title);

                        checkPageAccess(to, from, next);
                        adjustPageLayout(to, from, next);

                        Vue.Download.postOfflineLog();

                        store.commit('windowResize');
                        next();
                    } else {

                        //store.commit('logout');
                        throw new Error(
                            'ログインユーザー情報の取得に失敗しました',
                        );
                    }
                })
                .catch(res => {
                    console.error(res);
                    next({ path: '/login' });
                });
        } else {
            // ルート設定に定義されているタイトル文字列を用いて
            // 画面タイトルを変更する
            const title = to.meta.title;
            //console.log("to", store.state.currentTitle);

            const redirectPath = checkPageAccess(to, from);
            if (redirectPath) {
                //アクセス権なし、リダイレクトする
                next({ path: redirectPath });

            } else {
                adjustPageLayout(to, from, next);

                Vue.Download.postOfflineLog();

                store.commit('updateTitle', title);
                store.commit('windowResize');
                next();

            }
        }
    }
});

// router.beforeResolve( ( to, from, next ) => {
//     console.log( "router.beforeResolve :", to, from );
// 
//     next();
// } );

/**
 * 遷移先が決定した時に呼ばれる関数を登録する
 * 
 * ここで登録した関数は、「遷移」が行われない場合は呼ばれない
 * ここで登録した関数は、遷移を「行おうとした」場合には呼ばれない
 * ここで登録した関数は、最終的に遷移先が決定した時に呼ばれる
 */
router.afterEach((to, from) => {
    console.log("router.afterEach :", to, from);

    Vue.Download.persist();
    Vue.Download.onPageTransition(to);

});

/**
 * 画面へのアクセス権限をチェックする？
 * F2 No.96 アクセス権なしの場合はリダイレクトパスを返却するように修正
 * 
 * @param {*} to 
 * @param {*} from 
 */
function checkPageAccess(to, from) {
    var destPath = to.path;

    // 不正な画面遷移
    if (destPath == '/admin/preview') {
        if (store.state.previewOrigin.length == 0) {
            return '/admin/menu';
        }
    } else {
        // 権限不足判定
        var currentGrant = store.state.userInfo.grant;

        var isInvalidGrant = false;
        if (currentGrant == 1 /* 閲覧者 */ ) {
            // "/admin"から始まるパス(管理ページ系)問い合わせ判定
            isInvalidGrant =
                isInvalidGrant ||
                (destPath.startsWith('/admin') &&
                    //!destPath.startsWith('/admin/menu') && //F2 No.96 閲覧ユーザーは管理画面にはアクセスできない
                    !destPath.startsWith('/admin/logs'));

            if (isInvalidGrant) {
                // 権限不足のためユーザートップ(カテゴリ選択)に遷移
                return '/user/categories';
            }
        } else if (currentGrant == 2 /* 編集 */ ) {
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/users'); // ユーザー一覧
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/user/'); // ユーザー登録編集
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/groups'); // グループ一覧
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/group/'); // グループ登録編集
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/categories'); // カテゴリ一覧
            isInvalidGrant = isInvalidGrant || destPath.startsWith('/admin/category/'); // カテゴリ登録編集

            if (isInvalidGrant) {
                // 権限不足のため管理メニューに遷移
                return '/admin/menu'
            }
        }


        //ログイン中はログイン画面に遷移しない
        var authToken = Cookies.get('el-auth-token');
        if (authToken && destPath.startsWith('/login')) {
            return '/user/categories';
        }

    }

    if (destPath == '/') {
        // ルートが問い合わせされた場合は
        // カテゴリ選択画面に遷移する
        return '/user/categories';
    }

    return null;
}

/**
 * 画面のレイアウトを調整する？
 * 
 * @param {*} to 
 * @param {*} from 
 * @param {*} next 
 */
function adjustPageLayout(to, from, next) {
    var destPath = to.path;
    var srcPath = from.path;

    //console.log(srcPath, "->", destPath);
    if (destPath.startsWith('/user/checklist/')) {
        jQuery('body').css({ 'overflow-y': 'hidden' });
        jQuery('html').css({ 'overflow-y': 'hidden' });
        jQuery('#main-container').css({ 'overflow-y': 'hidden' });

        //console.log("in checklist");
    }
    if (srcPath.startsWith('/user/checklist/')) {
        jQuery('body').css({ 'overflow-y': 'auto' });
        jQuery('html').css({ 'overflow-y': 'auto' });
        jQuery('#main-container').css({ 'overflow-y': 'auto' });
        //console.log("out checklist");
    }
}

// アイコンクラス
Vue.component('arrow-up', {
    template: `
        <i class="fas fa-arrow-up "></i>
    `,
});
Vue.component('arrow-down', {
    template: `
        <i class="fas fa-arrow-down "></i>
    `,
});

// アイコンクラス
Vue.component('arrow-up-alt', {
    template: `
        <i class="far fa-arrow-alt-circle-up arrow-alt"></i>
    `,
});
Vue.component('arrow-down-alt', {
    template: `
        <i class="far fa-arrow-alt-circle-down arrow-alt"></i>
    `,
});

// 共通コンポーネント
import upDown from './components/commons/ArrowUpDown.vue';
Vue.component('arrow-up-down', upDown);

import upDownAlt from './components/commons/ArrowAltUpDown.vue';
Vue.component('arrow-up-down-alt', upDownAlt);

import overlay from './components/commons/OverlayComponent.vue';
Vue.component('overlay', overlay);

import globalControl from './components/commons/GlobalControl.vue';
Vue.component('global-control', globalControl);

window.Vue = Vue;

// 要素に v-focus を指定すると、その要素にフォーカスするようにする
Vue.directive('focus', {
    inserted: function(el) {
        el.focus();
    }
});

/*
 * メインコンポーネント
 */
const app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App />',
    util,
    store,
});

/*
 * タイトル変更用コンポーネント
 */
new Vue({
    el: '#title',
    computed: {
        realTitle() {
            return this.$store.state.currentTitle;
        },
    },
    util,
    store,
});

jQuery(document).ready(function() {
    jQuery(window).resize(function() {
        //console.log("win resize", store);

        store.commit('windowResize');
    });

    store.commit('windowResize');
});

/**
 * Service Worker を起動する
 */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {

        store.commit('overlay', true); //Service Workerがactivateになるまで操作させない

        navigator.serviceWorker.register("/service-worker.js").then(function(registration) {
            console.log('ServieWorker registration OK : ', registration.scope);
            //console.log(navigator.serviceWorker);

            var serviceWorker;
            if (registration.installing) {
                serviceWorker = registration.installing;

            } else if (registration.waiting) {
                serviceWorker = registration.waiting;

            } else if (registration.active) {
                //Service Worker稼働中　
                store.commit('overlay', false);
            }

            if (serviceWorker) {
                serviceWorker.addEventListener('statechange', function(e) {

                    console.log("service worker statechange.", e.target.state);
                    if (e.target.state == "activated") {
                        //Service Worker ステータス activate　
                        store.commit('overlay', false);
                    }
                });
            }

        }, function(error) {
            console.log('ServieWorker registration NG : ', error, error.message);
            store.commit('overlay', false);
        });
    });
}